/** Design System — Border-radius tokens (px, SLDS). */
export const radius = {
  none: 0,
  input: 4,
  button: 6,
  card: 12,
  dialog: 16,
  pill: 999,
  circle: 9999,
} as const;

export type Radius = typeof radius;
